import React from 'react';
import Header from '../_part/Header';
import '../_css/home.css'


function Home(){

    return(
        <div>
            <div className='home'>
                <h1>Welcome to Dris's Blog</h1>
                <p>running with Github Pages</p>

                <ul>
                    <li>sds</li>
                </ul>
 



                <div style={{paddingTop:"100%"}}></div>

            </div>

            <Header />

            <footer>
                <p style={{margin:"0"}}>hello</p>
            </footer>


        </div>
    );
}

export default Home;